module.exports = __webpack_public_path__ + "static/img/news82_17.5904a14.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news82/news82_17.webp
// module id = kMS3
// module chunks = 0